var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.39 244.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b2d3b"
    },
    d: "M130.19,33a89,89,0,1,0,89,89A89.12,89.12,0,0,0,130.19,33Zm0,150.06a61,61,0,1,1,61-61A61.1,61.1,0,0,1,130.19,183.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1b2d3b"
    },
    cx: 130.19,
    cy: 122.06,
    r: 26.17,
    transform: "matrix(0.99, -0.16, 0.16, 0.99, -17.87, 22.43)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomains);
export default __webpack_public_path__ + "static/media/domains.77684fc056ddda5d0fcee8024eee3b5e.svg";
export { ForwardRef as ReactComponent };